module.exports = __webpack_public_path__ + "static/media/22.bd5dc64f.jpg";